/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Support_Desc7Inputs */

const en_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant answers from your docs and policies, with escalation to a human when it matters.`)
};

const ar_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجابات فورية من مستنداتك وسياساتك، مع التصعيد إلى إنسان عند الحاجة.`)
};

const bn_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ডক আর পলিসি থেকে তাৎক্ষণিক উত্তর, দরকার হলে মানুষের কাছে পাঠানো।`)
};

const de_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sofortige Antworten aus Ihren Dokumenten und Richtlinien, mit Eskalation an einen Menschen, wenn es darauf ankommt.`)
};

const es_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas instantáneas desde sus documentos y políticas, con escalado a un humano cuando importa.`)
};

const fr_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses instantanées depuis vos documents et politiques, avec escalade vers un humain quand ça compte.`)
};

const pt_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas instantâneas a partir dos seus documentos e políticas, com escalada a um humano quando importa.`)
};

const zh_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于你的文档和政策即时作答，关键时刻升级到人工。`)
};

const tr_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgelerinizden ve politikalarınızdan anında yanıtlar, gerektiğinde insana yükseltme ile.`)
};

const ru_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мгновенные ответы из ваших доков и политик, с эскалацией человеку, когда важно.`)
};

const pl_svc_messaging_bots_support_desc7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błyskawiczne odpowiedzi z dokumentów i polityk, z eskalacją do człowieka, gdy to ważne.`)
};

/**
* | output |
* | --- |
* | "Instant answers from your docs and policies, with escalation to a human when it matters." |
*
* @param {Svc_Messaging_Bots_Support_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_support_desc7 = /** @type {((inputs?: Svc_Messaging_Bots_Support_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Support_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_support_desc7(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_support_desc7(inputs)
	if (locale === "de") return de_svc_messaging_bots_support_desc7(inputs)
	if (locale === "es") return es_svc_messaging_bots_support_desc7(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_support_desc7(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_support_desc7(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_support_desc7(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_support_desc7(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_support_desc7(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_support_desc7(inputs)
	return en_svc_messaging_bots_support_desc7(inputs)
});
export { svc_messaging_bots_support_desc7 as "svc_messaging-bots_SUPPORT_desc" }